<!-- HTML with Ionic Components -->
<ion-content class="page-configurations">
  <div
    *ngIf="diagnosticsConsent.granted"
    class="page-configurations__active-note"
    role="button"
    tabindex="0"
    (click)="scrollToDiagSection()"
    (keydown.enter)="scrollToDiagSection()"
    (keydown.space)="scrollToDiagSection(); $event.preventDefault()"
  >
    <span class="page-configurations__active-note__icon" aria-hidden="true">
      <ion-icon name="warning-outline"></ion-icon>
    </span>
    <span class="page-configurations__active-note__text">
      {{ "CONGIGURATION_PAGE.SUPPORT_TOP_NOTE" | translate }}
    </span>
    <ion-icon
      name="chevron-down-outline"
      class="page-configurations__active-note__chev"
      aria-hidden="true"
    ></ion-icon>
  </div>

  <div
    class="page-configurations__header"
    [class.page-configurations__header--with-note]="diagnosticsConsent.granted"
  >
    <ion-avatar class="page-configurations__header__avatar">
      <img
        *ngIf="user.client.image && user.client.image.length"
        src="{{ user.client.image }}"
        alt=""
      />
      <img
        *ngIf="!(user.client.image && user.client.image.length)"
        src="../../../assets/icon/icone-profile/profile_img.svg"
        alt=""
      />
    </ion-avatar>
    <h2 class="page-configurations__header__name">
      {{ user.client.first_name }} {{ user.client.last_name }}
    </h2>
  </div>

  <ion-list class="page-configurations__list">
    <ion-item
      *ngIf="role !== 'prestataire'"
      (click)="goTo('/configurations/payment-methods')"
      class="page-configurations__list__item"
    >
      {{ "CONGIGURATION_PAGE.UPDATE_PAYMENT" | translate }}
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </ion-item>
    <ion-item class="page-configurations__list__item">
      <div class="bloc-langues">
        {{ "CONGIGURATION_PAGE.UPDATE_LANGUAGE" | translate }}
        <div class="bloc-langues__group">
          <input
            type="radio"
            [(ngModel)]="langue"
            class="bloc-langues__group__radio"
            value="en"
            id="english"
            name="langue"
            (change)="changelang($event)"
          />
          <label class="bloc-langues__group__label" for="english">
            {{ "CONGIGURATION_PAGE.EN" | translate }}
          </label>
          <input
            type="radio"
            [(ngModel)]="langue"
            class="bloc-langues__group__radio"
            value="fr"
            id="french"
            name="langue"
            (change)="changelang($event)"
          />
          <label class="bloc-langues__group__label" for="french">{{
            "CONGIGURATION_PAGE.FR" | translate
          }}</label>
          <input
            type="radio"
            [(ngModel)]="langue"
            class="bloc-langues__group__radio"
            value="it"
            id="italien"
            name="langue"
            (change)="changelang($event)"
          />
          <label class="bloc-langues__group__label" for="italien">{{
            "CONGIGURATION_PAGE.IT" | translate
          }}</label>
        </div>
      </div>
    </ion-item>
    <ion-item class="page-configurations__list__item" (click)="openLegalsModal()">
      {{ "CONGIGURATION_PAGE.LEGALS" | translate }}
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </ion-item>

    <ion-item
      class="page-configurations__list__item"
      (click)="openConfidentialModal()"
    >
      {{ "CONGIGURATION_PAGE.CONFIDENTIAL" | translate }}
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </ion-item>
    <ion-item class="page-configurations__list__item" (click)="openCguModal()">
      {{ "CONGIGURATION_PAGE.CGU" | translate }}
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </ion-item>
    <ion-item
      class="page-configurations__list__item page-configurations__list__item--last"
      (click)="goTo('configurations/delete-account')"
    >
      {{ "CONGIGURATION_PAGE.DELET_ACCOUNT" | translate }}
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </ion-item>
  </ion-list>

  <section
    id="diag-section-anchor"
    class="page-configurations__support"
    [attr.aria-label]="'CONGIGURATION_PAGE.SUPPORT_SECTION_TITLE' | translate"
  >
    <p class="page-configurations__support__section-label">
      {{ "CONGIGURATION_PAGE.SUPPORT_SECTION_TITLE" | translate }}
    </p>

    <div
      class="page-configurations__support-card"
      [class.page-configurations__support-card--active]="diagnosticsConsent.granted"
    >
      <div class="page-configurations__support-card__row">
        <div class="page-configurations__support-card__icon-wrap" aria-hidden="true">
          <ion-icon name="medkit-outline"></ion-icon>
        </div>
        <div class="page-configurations__support-card__copy">
          <h3 class="page-configurations__support-card__title">
            {{ "CONGIGURATION_PAGE.SUPPORT_TOGGLE_TITLE" | translate }}
          </h3>
          <p class="page-configurations__support-card__desc">
            {{ "CONGIGURATION_PAGE.SUPPORT_TOGGLE_DESC" | translate }}
          </p>
        </div>
        <ion-toggle
          class="page-configurations__support-card__toggle"
          [checked]="diagnosticsConsent.granted"
          [attr.aria-label]="'CONGIGURATION_PAGE.SUPPORT_TOGGLE_TITLE' | translate"
          (ionChange)="onDiagnosticsToggle($event)"
        ></ion-toggle>
      </div>

      <div
        *ngIf="diagnosticsConsent.granted"
        class="page-configurations__support-card__status"
        role="status"
      >
        <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
        <span>{{ "CONGIGURATION_PAGE.SUPPORT_ACTIVE_STATUS" | translate }}</span>
      </div>
    </div>
  </section>

  <ng-container *ngIf="devModeEnabled">
    <ion-list class="page-configurations__list page-configurations__list--dev">
      <ion-item-divider class="page-configurations__dev-divider">
        <ion-label>Développeur</ion-label>
      </ion-item-divider>
      <ion-item
        class="page-configurations__list__item page-configurations__list__item--dev"
        (click)="openLogViewer()"
      >
        Log Viewer
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </ion-item>
      <ion-item
        class="page-configurations__list__item page-configurations__list__item--dev"
        (click)="disableDevMode()"
      >
        Désactiver le mode développeur
        <ion-icon name="close-circle-outline"></ion-icon>
      </ion-item>
    </ion-list>
  </ng-container>
</ion-content>
